'use strict';

var index = require('../../../define-properties/index.js');
var index$1 = require('../../../function-bind/index.js');
var implementation$1 = require('./implementation.js');
var polyfill = require('./polyfill.js');
var shim$1 = require('./shim.js');

var define = index;
var bind = index$1;

var implementation = implementation$1;
var getPolyfill = polyfill;
var shim = shim$1;

var bound = bind.call(Function.call, implementation);

define(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var function_prototype_name = bound;

module.exports = function_prototype_name;
